import React, { useEffect } from 'react';

const Spinner = () => {
  useEffect(() => {
    const styleId = 'button-spinner-style';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.innerHTML = `
        @keyframes spinner {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <div
      style={{
        animation: '400ms linear infinite spinner',
        borderBottom: '2px solid transparent',
        borderLeft: '2px solid white',
        borderRadius: '50%',
        borderRight: '2px solid transparent',
        borderTop: '2px solid white',
        boxSizing: 'border-box',
        height: 16,
        width: 16,
        margin: '0 auto'
      }}
    />
  );
};

export default Spinner;
